import { type IEmailValidatorResponse } from '@mahawi/eshop-rabbit';

export enum EEmailValidatorCorrelationId {
  AddressBook = 'addressBook',
  CheckoutBilling = 'checkout.billing',
  CheckoutDelivery = 'checkout.delivery',
  GiftRegistryConfirmBilling = 'giftRegistryConfirm.billing',
  GiftRegistryConfirmDelivery = 'giftRegistryConfirm.delivery',
  GiftRegistryContribution = 'giftRegistryContribution',
  Login = 'login',
  Watchdog = 'watchdog',
  WithdrawalConfirmationEmail = 'withdrawal.confirmationEmail',
  WithdrawalOrderEmail = 'withdrawal.orderEmail',
}

interface IEmailValidatorEntry {
  email: string;
  isLoading: boolean;
  result?: IEmailValidatorResponse;
  timedOut?: boolean;
}

export interface IEmailValidatorState {
  entries: Record<string, IEmailValidatorEntry>;
}

export interface IEmailValidatorVerify {
  payload: {
    correlationId: EEmailValidatorCorrelationId;
    email: string;
  };
}

export interface IEmailValidatorVerifyResponse {
  type: string;
  payload: {
    result: IEmailValidatorResponse;
  };
}

export type IEmailValidatorVerifyCallback = (
  arg0: IEmailValidatorVerifyResponse,
) => void;

export interface IEmailValidatorVerifyTimeout {
  payload: {
    correlationId: EEmailValidatorCorrelationId;
    email: string;
  };
}
